import type { EventCategory, EventType, KnownEventType } from "@safers/api";
const TYPE_LABELS: Record<string, string> = {
  NO_HELMET: "안전모",
  FIRE: "화재",
  INTRUSION: "침입",
  GAS_THRESHOLD_EXCEEDED: "가스",
  BAND_VITAL_ABNORMAL: "생체신호",
  HEAT_INDEX_EXCEEDED: "체감온도",
  // INTRUSION은 현재 API enum에서 제외됐지만 과거 이벤트의 표시명은 유지한다.
} satisfies Record<KnownEventType | "INTRUSION", string>;
export const EVENT_TYPES: readonly EventType[] = Object.keys(TYPE_LABELS);
const CATEGORY_LABELS: Record<string, string> = {
  DETECTION: "영상 감지",
  SAFETY: "안전 센서",
};
export function typeLabel(type: EventType): string {
  return TYPE_LABELS[type] ?? type;
}
export function categoryLabel(category: EventCategory): string {
  return CATEGORY_LABELS[category] ?? category;
}
